import React from 'react';
import { useAppSelector, useAppDispatch } from '../../../store/hooks';
import ComposerDownloadModal from './index';
import {
  addDownloadManagerLayer,
  closeDownloadManager,
  focusDownloadManager,
  minimizeDownloadManagerFeed,
  restoreDownloadManagerFeed,
} from '../../../store/downloadManager/downloadManagerSlice';
import type { DownloadType } from '../../../store/downloadManager/downloadManagerSlice';

const downloadTypes: DownloadType[] = ['angles', 'anglesPaddingJson', 'clips'];

const ComposerDownloadRoot: React.FC = () => {
  const dispatch = useAppDispatch();
  const { jobs } = useAppSelector((state) => state.downloadManagerStore);
  const visibleJobs = jobs.filter((job) => job.open);

  if (!visibleJobs.length) return null;

  return (
    <>
      {visibleJobs.map((job, idx) => {
        const feedJobs = visibleJobs.filter((item) => item.feedId === job.feedId);
        const orderedFeedJobs = [...feedJobs].sort((a, b) => (b.focusOrder || 0) - (a.focusOrder || 0));
        const activeJob = orderedFeedJobs[0];
        const isActiveJob = activeJob?.id === job.id;
        const groupMinimized = feedJobs.every((item) => item.minimized);
        const stackIndex = feedJobs.findIndex((item) => item.id === job.id);
        const usedTypes = new Set(feedJobs.map((item) => item.downloadType).filter(Boolean));
        const blockedTypes = feedJobs
          .filter((item) => item.id !== job.id)
          .map((item) => item.downloadType)
          .filter(Boolean) as DownloadType[];
        const canAddLayer =
          isActiveJob && !groupMinimized && feedJobs.length < downloadTypes.length && downloadTypes.some((type) => !usedTypes.has(type));

        return (
          <ComposerDownloadModal
            key={job.id}
            isOpen={job.open}
            isVisible={isActiveJob && !groupMinimized}
            showMinimized={isActiveJob && groupMinimized}
            switchModal={() => dispatch(closeDownloadManager({ id: job.id }))}
            jobId={job.id}
            feedId={job.feedId}
            feedTitle={job.feedTitle}
            downloadType={job.downloadType}
            blockedTypes={blockedTypes}
            canAddLayer={canAddLayer}
            tabs={feedJobs.map((item) => ({ id: item.id, downloadType: item.downloadType }))}
            onAddLayer={() => dispatch(addDownloadManagerLayer({ feedId: job.feedId, feedTitle: job.feedTitle }))}
            onSelectTab={(id) => dispatch(focusDownloadManager({ id }))}
            onMinimizeGroup={() => dispatch(minimizeDownloadManagerFeed({ feedId: job.feedId }))}
            onRestoreGroup={() => dispatch(restoreDownloadManagerFeed({ feedId: job.feedId, id: job.id }))}
            stackIndex={stackIndex >= 0 ? stackIndex : idx}
          />
        );
      })}
    </>
  );
};

export default ComposerDownloadRoot;
